import moment from "moment";
import MasterComponent from "../../../components/Forms";
import { MasterConfigs } from "../../../interfaces/entity";
import { constants } from "../../../constants/common";

const SalarySlip = () => {

  const salarySlipConfig: MasterConfigs = {
    api: () => '/salary-slips',
    title: 'Generate Salary Slip',
    // extraCall: (id) => '/salary-slips/send/mail/' + id,
    isActionTab: true,
    // moreActions: [
    //   {
    //     name: 'View PDF',
    //     action: 'pdf',
    //     getKey: (value) => value.salarySlipFile,
    //     keyDisabled: 'salarySlipSent',
    //     buttonText: 'Send Mail'
    //   },
    // ],
    maskClosable: false,
    modalTitle: (action) => action + ' Salary Slip',
    getColumns: () => {
      return [
        {
          title: 'Employee Name',
          dataIndex: 'employee',
          key: 'employee',
          render: (value) => {
            return value && value.firstName ? [value.firstName, value.lastName].join(' ') : '';
          },
        },
        {
          title: 'Leaves',
          dataIndex: 'leaves',
          key: 'leaves',
        },
        {
          title: 'PF Deduction?',
          dataIndex: 'PFDeduction',
          key: 'PFDeduction',
          formClassName: 'col-4 pb-2',
        },
        {
          title: 'TDS Deduction?',
          dataIndex: 'TDSDeduction',
          key: 'TDSDeduction',
        },
        {
          title: 'Start Date',
          dataIndex: 'startDate',
          key: 'startDate',
          render: (value) => {
            return moment(value).format('lll');
          },
        },
        {
          title: 'End Date',
          dataIndex: 'endTo',
          key: 'endTo',
          render: (value) => {
            return moment(value).format('lll');
          },
        },
        {
          title: 'Generated?',
          dataIndex: 'salarySlipGenrated',
          key: 'salarySlipGenrated',
          render: (text) => {
            return text ? 'Done' : 'In-Progress';
          }
        },
        {
          title: 'Sent?',
          dataIndex: 'salarySlipSent',
          key: 'salarySlipSent',
          render: (text) => {
            return text ? 'Sent' : 'In-Progress';
          }
        },
        {
          title: 'Approval Status',
          dataIndex: 'approvalStatus',
          key: 'approvalStatus',
          render: (value) => {
            return value == 'PENDING' ? 'Doesn\'t send for approval' : value;
          },
        },
      ];
    },
    getFormColumns: () => {
      return [
        {
          label: 'Employee name',
          name: 'employee',
          type: 'select',
          isCombo: true,
        },
        {
          label: 'Start Date',
          name: 'startDate',
          type: 'date',
        },
        {
          label: 'End Date',
          name: 'endTo',
          type: 'date',
        },
        {
          label: 'PF Deduction?',
          name: 'PFDeduction',
          type: 'select',
          children: ['Yes', 'No'].map(ele => ({ name: ele, value: ele })),
        },
        {
          label: 'TDS Deduction?',
          name: 'TDSDeduction',
          type: 'select',
          children: ['Yes', 'No'].map(ele => ({ name: ele, value: ele })),
        },
        {
          label: 'Total Leave',
          name: 'leaves',
          type: 'number',
        },
      ];
    },
    combo: [
      {
        name: 'emailTemplate',
        api: '/cms/emailTemplates',
        idKey: '_id',
        render: (e) => e.name,
      },
      {
        name: 'approvalFrom',
        api: '/users/CEO/list',
        idKey: '_id',
        render: (e) => constants.GET_FULL_NAME(e),
      },
      {
        name: 'employee',
        api: '/users',
        idKey: '_id',
        render: (e) => constants.GET_FULL_NAME(e),
      },
    ],
    getData: () => ({}),
    actions: [
      { name: 'Add Salary', actionType: 'Add', settings: { type: 'primary' } },
    ],
  };


  return (
    <MasterComponent config={salarySlipConfig} />
  );
}

export default SalarySlip;